// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"T1-z"};